<template>
  <AddressList
    v-if="showAddressList"
    v-model="searchVal"
    :addresses="filteredAddresses"
    :address-item-icon="addressItemIcon"
    :use-address-item-icon="useAddressItemIcon"
    :prepend-search-icon="prependSearchIcon"
    :placeholder-text="placeholderText"
    :theme="theme"
    @submit="submit"
    @manual:show="showManual"
  />
</template>

<script>
import AddressList from './AddressList'

export default {
  name: 'SmartAddressList',

  components: {
    AddressList
  },

  props: {
    addressItemIcon: {
      type: String,
      default: 'caret-right-circle.svg'
    },
    useAddressItemIcon: {
      type: Boolean,
      default: true
    },
    prependSearchIcon: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: 'Search...'
    },
    theme: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      searchVal: ''
    }
  },

  computed: {
    addresses () {
      return this.$store.state.AddressLookup.addresses
    },

    showAddressList () {
      return !!this.addresses[0].addressText
    },

    filteredAddresses () {
      return this.addresses.filter(address => {
        return address.addressText.toLowerCase().includes(this.searchVal.toLowerCase())
      })
    }
  },

  methods: {
    submit (address) {
      this.$emit('submit', address)
    },

    showManual () {
      this.$emit('manual:show')
    }
  }
}
</script>
